var _circle, _rect, _g, _mask, _rect2, _mask2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _mask3, _rect9, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIconPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#DFE1E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.2924,
    y: 13.8516,
    width: 21.2571,
    height: 28.1983,
    rx: 0.5,
    transform: "rotate(-6 12.2924 13.8516)",
    fill: "#9EA3B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_605_4185)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 24,
    height: 29,
    rx: 0.5,
    fill: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_605_4185",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 16.9214,
    width: 7.11111,
    height: 4.39394,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 16.9214,
    width: 7.11111,
    height: 4.39394,
    rx: 0.5,
    stroke: "#C6C9D5",
    strokeWidth: 2,
    mask: "url(#path-4-inside-1_605_4185)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-2_605_4185",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.5555,
    y: 16.9214,
    width: 9.77778,
    height: 4.39394,
    rx: 0.5
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5555,
    y: 16.9214,
    width: 9.77778,
    height: 4.39394,
    rx: 0.5,
    stroke: "#C6C9D5",
    strokeWidth: 2,
    mask: "url(#path-5-inside-2_605_4185)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 26.0605,
    width: 18.6667,
    height: 0.439394,
    rx: 0.219697,
    fill: "#DFE1E7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 29.1362,
    width: 18.6667,
    height: 0.439394,
    rx: 0.219697,
    fill: "#DFE1E7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 14.6362,
    width: 18.6667,
    height: 0.878788,
    rx: 0.439394,
    fill: "#DFE1E7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 32.2119,
    width: 18.6667,
    height: 0.439394,
    rx: 0.219697,
    fill: "#DFE1E7"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 35.2881,
    width: 18.6667,
    height: 0.439394,
    rx: 0.219697,
    fill: "#DFE1E7"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-3_605_4185",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 22.5454,
    width: 18.6667,
    height: 15.8182,
    rx: 0.5
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6666,
    y: 22.5454,
    width: 18.6667,
    height: 15.8182,
    rx: 0.5,
    stroke: "#C6C9D5",
    strokeWidth: 2,
    mask: "url(#path-11-inside-3_605_4185)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0381 44.5266L28.651 43.9483C28.4634 43.7794 28.3879 43.5183 28.4561 43.2738L29.3343 40.7874C29.4337 40.4309 29.5793 40.3594 29.9349 40.4566C30.0348 40.4839 30.1269 40.5342 30.2038 40.6034L32.5041 42.6746C32.7777 42.9209 32.7578 43.0968 32.5099 43.3722C32.4402 43.4496 32.3236 43.6053 32.2268 43.6436L30.0352 44.385C29.7992 44.4784 29.2257 44.6955 29.0381 44.5266Z",
    fill: "#576183"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6424 42.4853C28.8169 40.6216 29.3013 40.589 30.9692 38.6487L41.988 26.4111C42.6902 25.6312 43.9961 25.6624 44.905 26.4807C45.8138 27.299 45.9813 28.5945 45.2791 29.3744L34.2603 41.612C32.4044 43.4735 32.4679 44.3489 30.6424 42.4853Z",
    fill: "#9EA3B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.099 45.0133L28.5213 43.022L30.0352 44.3851L28.099 45.0133Z",
    fill: "#47506B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7326 35.2538L34.4185 34.971C34.1417 34.7218 34.0609 34.3603 34.238 34.1636L39.493 28.3274C39.6701 28.1307 40.0381 28.1732 40.3149 28.4225L40.6289 28.7053C40.9057 28.9545 40.9865 29.316 40.8094 29.5127L35.5544 35.3489C35.3773 35.5456 35.0094 35.503 34.7326 35.2538Z",
    fill: "#47506B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_605_4185",
    x: 17,
    y: 12,
    width: 25,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.278431 0 0 0 0 0.313726 0 0 0 0 0.419608 0 0 0 0.255436 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_605_4185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_605_4185",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIconPencil);
export default __webpack_public_path__ + "static/media/account-icon-pencil.85e26bb528c1d80ff354d5dca9fbb7e1.svg";
export { ForwardRef as ReactComponent };